import {selectUserId} from "../../../redux/reducers/privateStateReducer/selectors";
import {
  selectCurrentPlayer,
  selectGameType,
  selectSharedGameState
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {checkIfCurrentUserTurn} from "./checkIfCurrentUserTurn";
import {checkIfParallelSupplyPhase} from "../supply/parallelSupply";
import {selectSupplyActingPlayer} from "../supply/parallelSupplySelectors";

/**
 * Может ли пользователь действовать прямо сейчас — «его ход».
 *
 * В одновременной фазе снабжения сетевой игры ход у каждого игрока свой: он
 * длится, пока игрок (или бот, которым управляет админ) не закончил свою часть
 * фазы. В остальных фазах — прежнее правило checkIfCurrentUserTurn
 */
export const checkIfCurrentUserTurnInState = (state) => {
  if (checkIfParallelSupplyPhase(selectSharedGameState(state))) {
    return Boolean(selectSupplyActingPlayer(state));
  }
  return checkIfCurrentUserTurn(selectGameType(state), selectUserId(state), selectCurrentPlayer(state));
};
